import { render, staticRenderFns } from "./productCategory.vue?vue&type=template&id=3de37d54&scoped=true&"
import script from "./productCategory.vue?vue&type=script&lang=js&"
export * from "./productCategory.vue?vue&type=script&lang=js&"
import style0 from "./productCategory.vue?vue&type=style&index=0&id=3de37d54&prod&lang=less&scoped=true&"
import style1 from "./productCategory.vue?vue&type=style&index=1&id=3de37d54&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de37d54",
  null
  
)

export default component.exports